export class EmployeeAgreementTemplateBO {
  id: string | null;
  name: string;
  employeeApplicationCoverTemplate: EmployeeApplicationCoverTemplateBO = new EmployeeApplicationCoverTemplateBO();
  backgroundStudyAuthorizationTemplate: BackgroundStudyAuthorizationTemplateBO = new BackgroundStudyAuthorizationTemplateBO();
  payNoticeTemplate: PayNoticeTemplateBO = new PayNoticeTemplateBO();
  relationshipDisclosureTemplate: RelationshipDisclosureTemplateBO = new RelationshipDisclosureTemplateBO();
  employeeAgreementAndDirectDepositTemplate: EmployeeAgreementAndDirectDepositTemplateBO = new EmployeeAgreementAndDirectDepositTemplateBO();
  individualDirectSupportWorkerEnrollmentApplicationTemplate: IndividualDirectSupportWorkerEnrollmentApplicationTemplateBO = new IndividualDirectSupportWorkerEnrollmentApplicationTemplateBO();
  individualSupportWorkerProviderAgreementTemplate: IndividualSupportWorkerProviderAgreementTemplateBO = new IndividualSupportWorkerProviderAgreementTemplateBO();
  employmentEligibilityVerificationTemplate: EmploymentEligibilityVerificationTemplateBO = new EmploymentEligibilityVerificationTemplateBO();
  employeesWithholdingCertificateTemplate: EmployeesWithholdingCertificateTemplateBO = new EmployeesWithholdingCertificateTemplateBO();
  w4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplate: W4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplateBO = new W4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplateBO();
  w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplate: W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplateBO = new W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplateBO();
}

export class EmployeeApplicationCoverTemplateBO {
  employeeName: string;
}

export class BackgroundStudyAuthorizationTemplateBO {
  participantName: string;
  previousNamesUsed1: string;
  previousNamesUsed2: string;
  previousNamesUsedDate1: string | null;
  previousNamesUsedDate2: string | null;
  previous_Addresses_Used1: string;
  previous_Addresses_Used2: string;
  previous_Addresses_Used3: string;
  previous_Addresses_UsedDate1: string | null;
  previous_Addresses_UsedDate2: string | null;
  previous_Addresses_UsedDate3: string | null;
  applicantSignature: string;
  applicantSignatureDate: string | null;
  parentSignature: string;
  parentSignatureDate: string | null;
}

export class PayNoticeTemplateBO {
  effectiveDate: string | null;
  service: string;
  rate: number;
}

export class RelationshipDisclosureTemplateBO {
  relationshipName: string;
  employerandWantWorkers: boolean | null;
}

export class EmployeeAgreementAndDirectDepositTemplateBO {
  routing: string;
  account: string;
  checkingOrSaving: string;
}

export class IndividualDirectSupportWorkerEnrollmentApplicationTemplateBO {
  newHireOrReHire: string;
  previousEmployementEndDate: string | null;
  isMcoClaimsOnly: boolean | null;
  individualDswBackgroundStudyInfo: string | null;
  isQualifiedEnhancedRateTraining: boolean | null;
  optionalTrainingCompletionDate: string | null;
  optionalTrainingExpirationDate: string | null;
  isAffiliateIndividualDsw: boolean | null;
  orgAffiliationInfoSignDeclaration: boolean | null;
  facilityNpi: string;
  studyId: string;
  orgPersonalCompletingForm: string;
  orgPersonalSign: string;
  orgPersonalFax: string;
  programType: string;
  dswBackgroundStudyInfoTemplates: DswBackgroundStudyInfoTemplateBO[];
}

export class IndividualSupportWorkerProviderAgreementTemplateBO {
  directSupportWorkerInitial: string;
  umpi: string;
  signDeclaration: boolean | null;
  title: string;
}

export class EmploymentEligibilityVerificationTemplateBO {
  signOfPreparerorTraslator: string;
  signOfPreparerorTraslatorDate: string | null;
  preparerFirstName: string;
  preparerLastName: string;
  preparerCity: string;
  preparerState: string;
  preparerAddress: string;
  preparerZip: string;
  documentTitle: string;
  issuingAuthority: string;
  documentNumber: string;
  expirationDate: string | null;
  documentTitle1: string;
  issuingAuthority1: string;
  documentNumber1: string;
  expirationDate1: string | null;
  documentTitle2: string;
  issuingAuthority2: string;
  documentNumber2: string;
  expirationDate2: string | null;
  documentTitle3: string;
  issuingAuthority3: string;
  documentNumber3: string;
  expirationDate3: string | null;
  documentTitle4: string;
  issuingAuthority4: string;
  documentNumber4: string;
  expirationDate4: string | null;
  additionalInfo: string;
  penaltyOfPerjury: string;
  alien_Registration_Number: string;
  alien_Registration_ExpiryDate: string | null;
  alien_Registration_Number_Uscis_Number: string;
  form_I_94Admission_Number: string;
  foreign_Passport_Number: string;
  countryofIssuance: string;
  employerorAuthorizedMi: string;
  employerorAuthorizedCitizenship: string;
}

export class EmployeesWithholdingCertificateTemplateBO {
  qualifyingChildrenUnder_AgeSeventeen: number | null;
  otherDependents: number | null;
  total: number | null;
  otherIncome: number | null;
  deductions: number | null;
  additionalTax: number | null;
  otherAdjustmentTotal: number | null;
  multiJobsWorksheetFirstJobField: string;
  multiJobsWorksheetSecondjobField_a: string;
  multiJobsWorksheetSecondjobField_b: string;
  multiJobsWorksheetSecondjobField_c: string;
  multiJobsWorksheetThirdHobField: string;
  multiJobsWorksheetTourthJobField: string;
  deductionfirstamout: number | null;
  deductionSecondamount: number | null;
  deductionThirdamount: number | null;
  deductionFourthamount: number | null;
  deductionFifthamount: number | null;
  firstDateOfEmployeement: string | null;
  identificationNumber: string;
  maritalStatus: string;
  multipleJobsOrSpouseWorkSectionc:boolean =false;
}

export class W4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplateBO {
  exemption_minnesota_withholdingsec2: string;
  determine_minnesota_allowances: string;
  ifNoOneClaimyouasdependent: string;
  ifanyofFollowingApply: string;
  haveeitherworkingSpouseormorethanOneJob: string;
  filingstatusHeadofHousehold: string;
  deductionsandAdditionalIncomeWorksheet: string;
  minnesotaAllwances: string;
  additionalMinnesotawithholding: string;
  numberofdependents: string;
  state_domicile: string;
  reservation_name: string;
  enroll_no: string;
  phoneNumber: string;
  taxIdNumber: string;
  federal_Id_number: string;
}

export class W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplateBO {
  estimate_Minnesota_ItemizedDeductions: number | null;
  enterBasedOnFillingStatus: number | null;
  subtractStep2FromStep1: number | null;
  estimate_AdditionalStandardDeductions: number | null;
  addStep3AndStep4: number | null;
  estimateTaxableNonwageIncome: number | null;
  subtractStep6FromStep5: number | null;
  divideAmountOnStep7bySomeAmt: number | null;
  numberStepF: number | null;
  addStep8andStep9: number | null;
}

export class DswBackgroundStudyInfoTemplateBO {
  id: string | null;
  bsgNumber: string;
  applicationNumber: string;
  facilityId: string;
}

export class functionpermission {

}